var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F5EEE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.75C12.75 6.33437 12.4156 6 12 6C11.5844 6 11.25 6.33437 11.25 6.75V11.25H6.75C6.33437 11.25 6 11.5844 6 12C6 12.4156 6.33437 12.75 6.75 12.75H11.25V17.25C11.25 17.6656 11.5844 18 12 18C12.4156 18 12.75 17.6656 12.75 17.25V12.75H17.25C17.6656 12.75 18 12.4156 18 12C18 11.5844 17.6656 11.25 17.25 11.25H12.75V6.75Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.bc247aa05cb443dc429eabcc2b1a8b08.svg";
export { ForwardRef as ReactComponent };